import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import HowToFix from '../shared/HowToFix';
import { CompetitorsResults } from '../../types';

const passedResultMessage = 'This website is using a robots.txt file.';

export default function RobotsTxtSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    const updatedResultMessage = result.status === 'passed' ? passedResultMessage : result.message;

    let updatedCompetitorResults: CompetitorsResults | undefined = undefined;

    // TODO: remove this when the message is fixed on backend
    if (hasCompetitors) {
        updatedCompetitorResults = Object.keys(competitorsResults).reduce((accumulated, competitor) => {
            const status = competitorsResults[competitor].status;

            if (status === 'passed') {
                return { ...accumulated, [competitor]: { ...competitorsResults[competitor], message: passedResultMessage } };
            } else {
                return accumulated;
            }
        }, {});
    }

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={updatedResultMessage}
                    hasCompetitors={hasCompetitors}
                />

                {result.status === 'passed' && result.robots_txt_url && <RobotsTxtResult robotsTxtUrl={result.robots_txt_url} />}

                {result.status !== 'passed' && result.how_to_fix && (
                    <HowToFix
                        title={title}
                        howToFix={result.how_to_fix}
                        howToFixVideo={result.how_to_fix_video}
                    />
                )}

                {updatedCompetitorResults && (
                    <SectionCompetitorResults
                        results={updatedCompetitorResults}
                        relevance={relevance}
                        render={(result) => <>{result.robots_txt_url && <RobotsTxtResult robotsTxtUrl={result.robots_txt_url} />}</>}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type RobotsTxtResultProps = {
    robotsTxtUrl: string;
};

function RobotsTxtResult({ robotsTxtUrl }: RobotsTxtResultProps) {
    return (
        <div className="description-meta">
            <span className="single-result">
                <a
                    href={robotsTxtUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {robotsTxtUrl}
                </a>
            </span>
        </div>
    );
}
